<template>
  <div>
    <v-row style="width: 100%">
      <v-col style="width: 100%">
        <span class="font-weight-bold mt-1 text-truncate"
          >Relative distance between the two spacecrafts
        </span>
        <FullscreenGraphComponent
          :traces="getRelativeDistancePlotTraces"
          :layout="relativeDistancePlotLayout"
          title="Relative distance between the two spacecrafts"
          style="width: 100%; height: 200px"
          :maneuversDates="maneuversDate"
        />
      </v-col>
      <v-col>
        <span class="font-weight-bold mt-1 text-truncate"
          >3D relative chaser position (target-centered)
        </span>
        <FullscreenGraphComponent
          :traces="getRelativeDistancePlotTraces3D"
          :layout="trajectory3dPlotLayout"
          title="3D relative chaser position (target-centered)"
          style="width: 100%; height: 200px"
        />
      </v-col>
    </v-row>
    <v-row style="width: 100%; position: absolute; bottom: 0%">
      <div>
        <v-row>
          <v-col class="d-flex justify-center align-center"
            ><span class="font-weight-bold mt-1 text-truncate"
              >Relative distance along each axis
            </span></v-col
          >

          <v-col class="d-flex justify-center align-center">X : </v-col>
          <v-col>
            <v-select
              v-model="xAxisField"
              :items="axis"
              item-text="name"
              item-value="value"
            ></v-select>
          </v-col>
          <v-col class="d-flex justify-center align-center">Y : </v-col>
          <v-col>
            <v-select
              v-model="yAxisField"
              :items="axis"
              item-text="name"
              item-value="value"
            ></v-select>
          </v-col>
          <v-col />
        </v-row>

        <FullscreenGraphComponent
          :traces="getRelativeDistanceEachAxisTrace"
          :layout="relativeDistancePlotLayoutEachAxis"
          title="Relative distance between the two spacecrafts"
          style="width: 100%; height: 200px"
          :maneuversDates="maneuversDateEachAxis"
        />
      </div>
    </v-row>
  </div>
</template>

<script>
import FullscreenGraphComponent from '../Asterx/FullscreenGraphComponent.vue'
import defense from '../../mixins/defense'
export default {
  name: 'ScreeningCatalogueAnalysisPlotsConjunction',
  props: {
    satellitesDatas: {
      type: Array
    },
    timelineDates: {
      type: Array
    }
  },
  components: {
    FullscreenGraphComponent
  },
  mixins: [defense],
  data() {
    return {
      xAxisField: null,
      yAxisField: null,
      context: 'ExtendedRelativeDistanceResults',
      textDescription:
        'We trace the two satellite with a line to see the distance between them, the red point is the chaser satellite and the green is our target',
      axis: [
        { name: 'Relative distance T (km)', value: 'relativeDistanceT' },
        { name: 'Relative distance W (km)', value: 'relativeDistanceW' },
        { name: 'Relative distance N (km)', value: 'relativeDistanceN' },
        { name: 'Propagation dates', value: 'propagationDates' }
      ],
      tabItems: ['info', 'graph'],
      tab: null
    }
  },
  computed: {
    isAllDataLoaded() {
      return !(
        this.satellitesDatas.length > 1 &&
        this.satellitesDatas[0] != null &&
        this.satellitesDatas[1] != null
      )
    },

    getsatellitelinesData() {
      return this.satellitesDatas[0].lines[0]
    },
    relativeDistancePlotLayout() {
      return {
        xaxis: {
          title: {
            text: this.getLabelWithUnitFromPath(
              ['propagationDates'],
              this.context
            )
          }
        },
        yaxis: {
          title: {
            text: this.getLabelWithUnitFromPath(
              ['relativeDistanceEphemerides'],
              this.context
            )
          }
        }
      }
    },
    trajectory3dPlotLayout() {
      return {
        scene: {
          xaxis: {
            title: {
              text: this.getLabelWithUnitFromPath(
                ['relativeDistanceT'],
                this.context
              )
            }
          },
          yaxis: {
            title: {
              text: this.getLabelWithUnitFromPath(
                ['relativeDistanceN'],
                this.context
              )
            }
          },
          zaxis: {
            title: {
              text: this.getLabelWithUnitFromPath(
                ['relativeDistanceW'],
                this.context
              )
            }
          },
          aspectmode: 'manual'
        }
      }
    },
    relativeDistancePlotLayoutEachAxis() {
      const xType = this.xAxisField
      const yType = this.yAxisField
      let textX = null
      let textY = null
      if (xType != null && yType != null && xType !== yType) {
        textX = this.getLabelWithUnitFromPath([xType], this.context)
        textY = this.getLabelWithUnitFromPath([yType], this.context)
      }
      return {
        xaxis: {
          title: { text: textX }
        },
        yaxis: {
          title: { text: textY }
        }
      }
    },

    getRelativeDistancePlotTraces() {
      let x
      let y
      if (!this.isAllDataLoaded) {
        x = this.satellitesDatas[0].dates.map((value) =>
          this.getDisplayValueFromPath(
            value,
            ['propagationDates'],
            this.context
          )
        )
        y = this.getsatellitelinesData.relativeDistanceEphemerides.map(
          (value) =>
            this.getDisplayValueFromPath(
              value,
              ['relativeDistanceEphemerides'],
              this.context
            )
        )
      } else {
        x = undefined
        y = undefined
      }
      return [
        {
          x: x,
          y: y,
          marker: {
            color: this.$vuetify.theme.dark ? 'white' : '#1E1E1E'
          },
          showlegend: false,
          hovertemplate: '%{y}<extra></extra>'
        }
      ]
    },

    getRelativeDistancePlotTraces3D() {
      let x
      let y
      let z
      if (!this.isAllDataLoaded) {
        x = this.getsatellitelinesData.relativeDistanceT.map((value) =>
          this.getDisplayValueFromPath(
            value,
            ['relativeDistanceT'],
            this.context
          )
        )
        y = this.getsatellitelinesData.relativeDistanceN.map((value) =>
          this.getDisplayValueFromPath(
            value,
            ['relativeDistanceN'],
            this.context
          )
        )
        z = this.getsatellitelinesData.relativeDistanceW.map((value) =>
          this.getDisplayValueFromPath(
            value,
            ['relativeDistanceW'],
            this.context
          )
        )
      } else {
        x = undefined
        y = undefined
        z = undefined
      }

      return [
        {
          x: x,
          y: y,
          z: z,
          marker: {
            color: this.$vuetify.theme.dark ? 'white' : '#1E1E1E'
          },
          hovertemplate:
            '<b>T</b>: %{x}' + '<br><b>N</b>: %{y}' + '<br><b>W</b>: %{z}',
          type: 'scatter3d',
          mode: 'lines',
          autosize: false,
          line: {
            width: 2
          },
          name: 'chaser'
        },
        {
          x: [0],
          y: [0],
          z: [0],
          marker: {
            color: 'green',
            size: 5
          },
          line: {
            color: 'transparent'
          },
          type: 'scatter3d',
          name: 'target'
        }
      ]
    },

    getRelativeDistanceEachAxisTrace() {
      const xType = this.xAxisField
      const yType = this.yAxisField
      let x
      let y
      if (xType != null && yType != null && xType !== yType) {
        if (xType === 'propagationDates') {
          x = this.satellitesDatas[0].dates.map((value) =>
            this.getDisplayValueFromPath(
              value,
              ['propagationDates'],
              this.context
            )
          )
        } else {
          x = this.getsatellitelinesData[xType].map((value) =>
            this.getDisplayValueFromPath(value, [xType], this.context)
          )
        }
        if (yType === 'propagationDates') {
          y = this.satellitesDatas[0].dates.map((value) =>
            this.getDisplayValueFromPath(
              value,
              ['propagationDates'],
              this.context
            )
          )
        } else {
          y = this.getsatellitelinesData[yType].map((value) =>
            this.getDisplayValueFromPath(value, [yType], this.context)
          )
        }
      } else {
        x = undefined
        y = undefined
      }
      return [
        {
          x: x,
          y: y,
          marker: {
            color: this.$vuetify.theme.dark ? 'white' : '#1E1E1E'
          },
          showlegend: false,
          hovertemplate: '%{y}<extra></extra>'
        }
      ]
    },
    maneuversDate() {
      if (this.timelineDates[1]) {
        return [
          {
            dates: [this.timelineDates[1].date],
            legendText: 'CloseastApproach',
            color: '#5757ff',
            opacity: 1
          }
        ]
      } else {
        return []
      }
    },
    maneuversDateEachAxis() {
      const xType = this.xAxisField
      const yType = this.yAxisField
      if (xType === 'propagationDates') {
        return this.maneuversDate
      } else if (yType === 'propagationDates') {
        return [
          {
            dates: [this.timelineDates[1].date],
            legendText: 'Detection Date',
            color: '#5757ff',
            opacity: 1,
            axis: 'y'
          }
        ]
      } else {
        return []
      }
    }
  }
}
</script>
<style></style>
